export class Days {
    static Monday = {
        Id: "Monday",
        Name: "Понедельник",
        ShortName: "Пн",
        Index: 1,
    };
    static Tuesday = {
        Id: "Tuesday",
        Name: "Вторник",
        ShortName: "Вт",
        Index: 2,
    };
    static Wednesday = {
        Id: "Wednesday",
        Name: "Среда",
        ShortName: "Ср",
        Index: 3,
    };
    static Thursday = {
        Id: "Thursday",
        Name: "Четверг",
        ShortName: "Чт",
        Index: 4,
    };
    static Friday = {
        Id: "Friday",
        Name: "Пятница",
        ShortName: "Пт",
        Index: 5,
    };
    static Saturday = {
        Id: "Saturday",
        Name: "Суббота",
        ShortName: "Сб",
        Index: 6,
    };
    static Sunday = {
        Id: "Sunday",
        Name: "Воскресенье",
        ShortName: "Вс",
        Index: 7,
    };

    static GetAllDays = function () {
        return [
            Days.Monday,
            Days.Tuesday,
            Days.Wednesday,
            Days.Thursday,
            Days.Friday,
            Days.Saturday,
            Days.Sunday,
        ];
    };
}
